import React from 'react';
import { createRoot } from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import App from './App.tsx';
import './index.css';
import './i18n';
import { useLenis } from './hooks/useLenis';

export default function Root() {
  useLenis();
  return (
    <>
      <App />
      <Analytics />
      <SpeedInsights />
    </>
  );
}

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  );
} else {
  console.error('❌ No se encontró el <div id="root"> en el HTML.');
}
